/* =====================================================
   BALMY GLOBAL JS
   ===================================================== */

/*
  .bline animated underline trigger
  Viewport'a girince .bline--visible sınıfı eklenir,
  bu da CSS animasyonu tetikler (soldan sağa çizgi).
*/
(function () {
  function initBline() {
    var els = document.querySelectorAll('.bline:not(.bline--visible)');
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bline--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4, rootMargin: '0px 0px -30px 0px' }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBline);
  } else {
    initBline();
  }
})();
